type IconProps = {
  className?: string;
};

export function TooltipIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00005 3C10.2638 3 11.2882 4.02443 11.2882 5.28814V18.7119C11.2882 19.9756 10.2638 21 9.00005 21C7.73635 21 6.71191 19.9756 6.71191 18.7119V5.28814C6.71191 4.02443 7.73635 3 9.00005 3Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.72858e-08 11.9999C4.23553e-08 10.7362 1.02443 9.71181 2.28814 9.71181L15.7119 9.71181C16.9756 9.71181 18 10.7362 18 11.9999C18 13.2637 16.9756 14.2881 15.7119 14.2881L2.28814 14.2881C1.02443 14.2881 1.22163e-08 13.2637 2.72858e-08 11.9999Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.63553 5.63595C3.52911 4.74238 4.97788 4.74238 5.87145 5.63595L15.3635 15.128C16.257 16.0215 16.257 17.4703 15.3635 18.3639C14.4699 19.2574 13.0211 19.2574 12.1276 18.3639L2.63554 8.87186C1.74196 7.97829 1.74196 6.52952 2.63553 5.63595Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.63595 18.364C1.74238 17.4704 1.74238 16.0216 2.63595 15.1281L12.128 5.63605C13.0215 4.74247 14.4703 4.74247 15.3639 5.63605C16.2574 6.52962 16.2575 7.97839 15.3639 8.87196L5.87186 18.364C4.97829 19.2575 3.52952 19.2575 2.63595 18.364Z"
        fill="currentColor"
      />
    </svg>
  );
}
